import { render, staticRenderFns } from "./ProjectsManagementList.vue?vue&type=template&id=6718756c"
import script from "./ProjectsManagementList.vue?vue&type=script&lang=js"
export * from "./ProjectsManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports